import { ApolloClient, InMemoryCache } from "@apollo/client";

export const client = new ApolloClient({
  uri: process.env.API || `https://dev.api.dunafood.hu`,
  //uri: process.env.ENDPOINT ? `https://${process.env.ENDPOINT}` : process.env.NODE_ENV === "production" ? "https://ekdelivery.xyz" : "https://localhost/api",
  //uri: "https://ekdelivery.xyz",
  //uri: "http://127.0.0.1:4000", //
  cache: new InMemoryCache(),
});
